import { render, staticRenderFns } from "./golongantabungan.vue?vue&type=template&id=7255539e&scoped=true"
import script from "./golongantabungan.vue?vue&type=script&lang=js"
export * from "./golongantabungan.vue?vue&type=script&lang=js"
import style0 from "./golongantabungan.vue?vue&type=style&index=0&id=7255539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7255539e",
  null
  
)

export default component.exports